export default "__VITE_ASSET__BILcVIYT__"